import { useQuery } from "@tanstack/react-query";
import { fetchQuestionBankGuessScore } from "../services/questionBankQuestionService";

function normalizeGuessScore(payload = {}) {
  return {
    subjectName: payload?.subject_name || "",
    topicTitle: payload?.topic_title || "",
    guessQuestions: Number(payload?.guess_questions_count || 0),
    rightGuess: Number(payload?.right_guess_count || 0),
    wrongGuess: Number(payload?.wrong_guess_count || 0),
    score: payload?.guess_score_percent || "0%",
  };
}

export function useQuestionBankGuessScore(params = {}, options = {}) {
  return useQuery({
    queryKey: ["questionBankGuessScore", params],
    queryFn: async () => {
      const { payload } = await fetchQuestionBankGuessScore(params);
      return normalizeGuessScore(payload);
    },
    enabled: options.enabled ?? true,
    staleTime: 2 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    placeholderData: (previousData) =>
      previousData ?? {
        subjectName: "",
        topicTitle: "",
        guessQuestions: 0,
        rightGuess: 0,
        wrongGuess: 0,
        score: "0%",
      },
  });
}
